import { Expose } from "class-transformer"
import { IsDefined, IsNumber } from "class-validator"

export class QuizEntity {
    @Expose()
    @IsDefined()
    @IsNumber()
    id!: number;
}